import { useCallback } from 'react'
import useQueryParams from '../../../hooks/useQueryParams'

const QUERY_PARAMS_SCHEMA = {
  page: Number,
  query: String,
  checkDate: String,
  perPage: Number,
}

export default function useFilters(initialValues = {}) {
  const [conditions, setConditions] = useQueryParams({
    initialValues,
    schema: QUERY_PARAMS_SCHEMA,
  })

  const handleFilterChange = useCallback(
    args => {
      setConditions({
        ...conditions,
        ...args,
        page: 1,
      })
    },
    [conditions, setConditions],
  )

  const handlePageChange = useCallback(
    page => setConditions({ ...conditions, page }),
    [conditions, setConditions],
  )

  return {
    conditions,
    setConditions,
    handlePageChange,
    handleFilterChange,
  }
}
